import { compose } from 'recompose'
import { withPurchasePowerProps } from '../../../features/homeowners/composables/withMinimumEquityAndGemDisplayProps'
import { PurchasingPowerPanel } from '../../../constants/notificationRefs'
import { CUSTOMER_MESSAGES } from '../../../constants/customerMessages'
import gems from './gems'

const defaultDM = {
  question: CUSTOMER_MESSAGES.PURCHASING_POWER.message,
  topic: CUSTOMER_MESSAGES.PURCHASING_POWER.topic
}

const PurchasingPowerContainer = compose(
  withPurchasePowerProps({
    gems,
    defaultDM,
    cardRef: PurchasingPowerPanel,
    padding: 50
  })
)

export default PurchasingPowerContainer
